import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TBulkPreview = components['schemas']['BulkOperationPreviewResDto'];
export type TBulkOperation = components['schemas']['BulkOperationResDto'];
export type TBulkCancel = components['schemas']['BulkOperationCancelResDto'];
export const bulkOperation = (id: string): Promise<TBulkOperation> =>
  unwrap(api.GET('/v1/bulk-operations/{id}', { params: { path: { id } } }));

export const cancelBulkOperation = (id: string): Promise<TBulkCancel> =>
  unwrap(api.POST('/v1/bulk-operations/{id}/cancel', { params: { path: { id } } }));

export const isFinished = (operation: TBulkOperation): boolean =>
  ['done', 'failed', 'cancelled'].includes(operation.state);

// Unlike cancel, the batch in hand finishes and the operation settles as done.
export const stopBulkAfterBatch = (id: string): Promise<TBulkOperation> =>
  unwrap(api.POST('/v1/bulk-operations/{id}/stop-after-batch', { params: { path: { id } } }));

export const bulkKeys = {
  one: (id: string) => ['bulk-operation', id] as const,
};

export type TBulkKind = TBulkOperation['kind'];

export const listBulkOperations = (kind: TBulkKind, active?: boolean): Promise<TBulkOperation[]> =>
  unwrap(api.GET('/v1/bulk-operations', { params: { query: { kind, active } } }));
